import script from "./BaseFilterComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseFilterComponent.vue?vue&type=script&setup=true&lang=ts"

import "./BaseFilterComponent.vue?vue&type=style&index=0&id=6add221c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6add221c"]])

export default __exports__